// extracted by mini-css-extract-plugin
export var aircallIframe = "_dw-3";
export var fabContainer = "_dw-5";
export var fabRinging = "_dw-6";
export var loadingOverlay = "_dw-4";
export var pulse = "_dw-7";
export var widgetContent = "_dw-2";
export var widgetPanel = "_dw-0";
export var widgetPanelExpanded = "_dw-1";